'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _getIsAdmin = require('ui-addon-upgrades/_core/common/eligibility/getIsAdmin');

var _AdminPrompt = require('ui-addon-upgrades/_core/common/components/AdminPrompt');

var _AdminTypes = require('ui-addon-upgrades/_core/common/constants/AdminTypes');

var _AdminModalTypes = require('ui-addon-upgrades/_core/common/constants/AdminModalTypes');

var _AdminModalTypes2 = _interopRequireDefault(_AdminModalTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdminOnlyWrapper = function (_Component) {
  _inherits(AdminOnlyWrapper, _Component);

  function AdminOnlyWrapper(props) {
    _classCallCheck(this, AdminOnlyWrapper);

    var _this = _possibleConstructorReturn(this, (AdminOnlyWrapper.__proto__ || Object.getPrototypeOf(AdminOnlyWrapper)).call(this, props));

    _this.state = {
      isAdmin: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(AdminOnlyWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var adminType = this.props.adminType;


      (0, _getIsAdmin.getIsAdmin)(adminType).then(function (isAdmin) {
        return _this2.setState({ isAdmin: isAdmin });
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          modalType = _props.modalType,
          merchandiseId = _props.merchandiseId,
          quoteLink = _props.quoteLink;


      return (0, _AdminPrompt.AdminPrompt)({
        modalType: modalType,
        merchandiseId: merchandiseId,
        quoteLink: quoteLink
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isAdmin = this.state.isAdmin;
      var children = this.props.children;

      var child = _react.Children.only(children);

      if (!isAdmin) {
        var newProps = (0, _underscore.omit)(_extends({}, child.props, {
          onClick: this.handleClick
        }), 'href');

        return _react2.default.createElement(child.type, newProps);
      }
      return child;
    }
  }]);

  return AdminOnlyWrapper;
}(_react.Component);

AdminOnlyWrapper.defaultProps = {
  adminType: _AdminTypes.TEAM,
  modalType: _AdminModalTypes2.default.DEFAULT
};

AdminOnlyWrapper.propTypes = {
  adminType: _react.PropTypes.oneOf([_AdminTypes.BILLING, _AdminTypes.TEAM]).isRequired,
  children: _react.PropTypes.node.isRequired,
  merchandiseId: _react.PropTypes.number,
  modalType: _react.PropTypes.oneOf(Object.values(_AdminModalTypes2.default || {})),
  quoteLink: _react.PropTypes.string
};

exports.default = AdminOnlyWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/AdminOnlyWrapper.js
// module id = 220
// module chunks = 3 4 5